import React from 'react';
import AppIcon from '../AppIcon/AppIcon';
import styles from './SearchBar.module.css';

const SearchBar = ({ value, onChange, placeholder = "Search..." }) => {
  return (
    <div className={styles.searchContainer}>
      <span className={styles.searchIcon}>
        <AppIcon name="search" size={16} />
      </span>
      <input
        type="text"
        className={styles.searchInput}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
      />
      {value && (
        <button
          className={styles.clearBtn}
          onClick={() => onChange('')}
          title="Clear search"
        >
          ✕
        </button>
      )}
    </div>
  );
};

export default SearchBar;

